import { render, staticRenderFns } from "./byq1.vue?vue&type=template&id=04ea4468&scoped=true&"
import script from "./byq1.vue?vue&type=script&lang=js&"
export * from "./byq1.vue?vue&type=script&lang=js&"
import style0 from "./byq1.vue?vue&type=style&index=0&id=04ea4468&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ea4468",
  null
  
)

export default component.exports